import React from "react";
import FormInput from "Common/Custom/FormInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import FormInputFile from "Common/Custom/FormInputFile";
import FormTextarea from "Common/Custom/FormTextarea";

const AddAboutUsForm = ({
    fields = [],
    values = {},
    errors = {},
    handleChange = () => { },
    handleSubmit = () => { },
    loading = false,
    handleFileChange = () => { },
    imagePreview = "",
}) => {
    return (
        <PageBody
            headerchildren={<HeadingOne>Create About Us</HeadingOne>}
            onSubmit={handleSubmit}
        >
            {fields.map((field) => {
                if (field.type === "alert") {
                    return (
                        <div className="alert alert-info">
                            {field.value}
                        </div>
                    )
                }
                if (field.type === "file") {
                    return (
                        <FormInputFile
                            key={field.name}
                            field={field}
                            handleChange={handleFileChange}
                            error={errors[field.name]}
                            imagePreview={field.name === "story_image" ? imagePreview : undefined}
                        />
                    );
                }
                if (field.type === "textarea") {
                    return (
                        <FormTextarea
                            key={field.name}
                            field={field}
                            value={values[field.name]}
                            handleChange={handleChange}
                            error={errors[field.name]}
                        />
                    );
                }
                return (
                    <FormInput
                        key={field.name}
                        field={field}
                        value={values[field.name]}
                        handleChange={handleChange}
                        error={errors[field.name]}
                    />
                );
            })}

            <FormSubmitButton
                label="Create About Us"
                loading={loading}
                colSize="col-12"
                align="end"
            />
        </PageBody>
    );
};

export default AddAboutUsForm;
